export const TimeUtil = {
  formatTime: function (timestamp) {
    if (!timestamp) {
      return '-'
    }
    let date = new Date(timestamp)
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
    let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
  },
  format: function (datetime, fmt) {
    if (!datetime) {
      return ''
    }
    var o = {
      'M+': datetime.getMonth() + 1, // 月份
      'd+': datetime.getDate(), // 日
      'h+': datetime.getHours(), // 小时
      'm+': datetime.getMinutes(), // 分
      's+': datetime.getSeconds(), // 秒
      'q+': Math.floor((datetime.getMonth() + 3) / 3), // 季度
      'S': datetime.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (datetime.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },
  getLastDay () {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24)

    return [start, end]
  },
  getToday () {
    return [this.getDayStart(new Date()), this.getDayEnd(new Date())]
  },
  getYesterday () {
    let yesterday = new Date(new Date().getTime() - 3600 * 1000 * 24)
    return [this.getDayStart(yesterday), this.getDayEnd(yesterday)]
  },
  getLastWeek () {
    let date = new Date(new Date().getTime() - 7 * 3600 * 1000 * 24)
    return [this.getDayStart(date), this.getDayEnd(new Date())]
  },
  getDayStart (date) {
    let newDate = new Date()
    newDate.setTime(date.getTime())
    newDate.setHours(0)
    newDate.setMinutes(0)
    newDate.setSeconds(0)
    return newDate
  },
  getDayEnd (date) {
    let newDate = new Date()
    newDate.setTime(date.getTime())
    newDate.setHours(23)
    newDate.setMinutes(59)
    newDate.setSeconds(59)
    return newDate
  }
}



// WEBPACK FOOTER //
// ./src/utils/TimeUtil.js